import { Step, StepButton, Stepper } from '@mui/material';
import React from 'react';

interface Props {
  activeStep: number;
  onClick: (step: number) => void;
}

const validateStepOne = () => true;
const validateStepTwo = () => true;
const validateStepThree = () => false; // test to fail validation to prevent step navigation
const validateStepFour = () => true;

const handleValidationStep = (activeStep: number) => {
  switch (activeStep) {
    case 0:
      return validateStepOne();
    case 1:
      return validateStepTwo();
    case 2:
      return validateStepThree();
    case 3:
      return validateStepFour();
  }
};

const steps = ['Overview', 'Feed Programs', 'Finance', 'Run'];

const StepsSideBar: React.FC<Props> = ({ activeStep, onClick }) => {
  return (
    <Stepper activeStep={activeStep} orientation="vertical">
      {steps.map((step) => (
        <Step
          key={step}
          sx={{
            // hacky fix to color label. This can be consolidated into theme
            '& .MuiStepLabel-root': {
              '& .MuiStepLabel-labelContainer': {
                '& .Mui-active': {
                  color: 'white',
                },
              },
              '& .Mui-completed': {
                fill: 'white',
                color: 'white !important',
              },
            },
          }}>
          <StepButton disabled>{step}</StepButton>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepsSideBar;
